import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteManagerPrintOptionsListing } from './Pages'

export const RouteManagerPrintOptionsRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={RouteManagerPrintOptionsListing} />
    </Fragment>
)